import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 1.5rem;
`;

const EmptyWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 3rem 2rem;
  color: var(--text-muted);
`;

const EmptyIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  opacity: 0.35;
`;

const EmptyTitle = styled.h4`
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 0 0 0.5rem;
`;

const EmptyDesc = styled.p`
  font-size: 0.875rem;
  max-width: 320px;
  line-height: 1.6;
  margin: 0;
`;

const AskContextCanvas: React.FC = () => {
  return (
    <Wrapper>
      <EmptyWrap>
        <EmptyIcon>💬</EmptyIcon>
        <EmptyTitle>Conversation Context</EmptyTitle>
        <EmptyDesc>
          Details and insights will appear here as the conversation develops.
        </EmptyDesc>
      </EmptyWrap>
    </Wrapper>
  );
};

export default AskContextCanvas;
